module.exports = __webpack_public_path__ + "img/page04_logo.8e9e87dd.png";